// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { getAccountsDataView } from "@insite/client-framework/Store/Data/Accounts/AccountsSelector";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import PageTitleCount from "@conklin/App/Components/Common/PageTitleCount";
import React, { FC } from "react";
const UserListTitleCount: FC<WidgetProps> = () => {
    const { accountsDataView } = useAppSelector(state => {
        return {
            accountsDataView: getAccountsDataView(state, state.pages.userList.getAccountsParameter),
        };
    });
    return (
        <PageTitleCount
            countNumber={(accountsDataView.value && accountsDataView.pagination?.totalItemCount) || 0}
            noun="User"
        />
    );
};
const widgetModule: WidgetModule = {
    component: UserListTitleCount,
    definition: {
        group: "User List",
        displayName: "User List Title Count",
        allowedContexts: ["UserListPage"],
    },
};
export default widgetModule;
